// ============================================================
// Attendance API
// ============================================================

import client from './axios';

export const attendanceApi = {
  // Staff Attendance Settings
  getSettings: async (schoolId) => {
    const response = await client.get('/attendance-settings/', {
      params: { school_id: schoolId },
    });
    return response.data;
  },

  // Student Attendance Settings
  getStudentAttendanceSettings: async (schoolId) => {
    const response = await client.get('/student-attendance-settings/', {
      params: { school_id: schoolId },
    });
    return response.data;
  },

  updateStudentAttendanceSettings: async (schoolId, payload) => {
    const response = await client.put('/student-attendance-settings/', payload, {
      params: { school_id: schoolId },
    });
    return response.data;
  },

  // Student Attendance — Mark Attendance
  getStudentsForAttendance: async (schoolId, { classId, sectionId, date, periodNo = 0 }) => {
    const response = await client.get('/attendance/students', {
      params: {
        school_id: schoolId,
        class_id: classId,
        section_id: sectionId,
        attendance_date: date,
        period_no: periodNo,
      },
    });
    return response.data;
  },

  submitStudentAttendance: async (schoolId, payload) => {
    const response = await client.post('/attendance/', payload, {
      params: { school_id: schoolId },
    });
    return response.data;
  },

  updateStudentAttendance: async (schoolId, sessionId, payload) => {
    const response = await client.put('/attendance/', payload, {
      params: { school_id: schoolId, attendance_session_id: sessionId },
    });
    return response.data;
  },

  updateSettings: async (schoolId, payload) => {
    const response = await client.put(`/attendance-settings/settings?school_id=${schoolId}`, payload);
    return response.data;
  },

  regenerateQrSecret: async (schoolId) => {
    const response = await client.post(`/attendance-settings/qr/regenerate?school_id=${schoolId}`, {});
    return response.data;
  },

  // QR Code
  getQrData: async (schoolId) => {
    const response = await client.get('/attendance-qr/qr', {
      params: { school_id: schoolId, _t: Date.now() },
    });
    return response.data;
  },

  scanQr: async (schoolId, payload) => {
    const response = await client.post(`/attendance/scan?school_id=${schoolId}`, payload);
    return response.data;
  },

  // View / Reports
  getTodaySummary: async (schoolId) => {
    const response = await client.get('/attendance-view/today', {
      params: { school_id: schoolId },
    });
    return response.data;
  },

  getAttendanceLogs: async (schoolId, params = {}) => {
    const response = await client.get('/attendance-view/', {
      params: { school_id: schoolId, ...params }, // e.g. page, page_size
    });
    return response.data;
  },

  getStaffAttendanceDate: async (schoolId, staffId, date) => {
    const response = await client.get(`/attendance-view/staff/${staffId}`, {
      params: { school_id: schoolId, attendance_date: date }
    });
    return response.data;
  },

  getMyAttendanceToday: async () => {
    const response = await client.get('/attendance-view/me');
    return response.data;
  },

  getMyAttendanceHistory: async (month, year) => {
    const response = await client.get('/attendance-view/me/history', {
      params: { month, year }
    });
    return response.data;
  }
};
